import { render, staticRenderFns } from "./createAfterSales.vue?vue&type=template&id=b45e800e&"
import script from "./createAfterSales.vue?vue&type=script&lang=js&"
export * from "./createAfterSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports